<template>
    <section id="add-cross-prom" class="step-content-slot">
        <div class="wizard-component container">
            <Heading
                title="Add CrossProm Info"
                description="Add your cross-promotion information that your partner campaigns will post in their updates. You can edit
                            this information to adjust to your needs"
            />
            <div class="wizard-content mt-4">
                <div class="row">
                    <div class="col-md-10 col-12">
                        <div class="row">
                            <div class="col-md-5 col-12">
                                <div class="left-side">
                                    <div
                                        @dragover.prevent
                                        id="img-dragover"
                                        @drop.prevent="onImageUpload($event.dataTransfer.files[0])"
                                        class="drag-img-wrap">
                                        <label v-b-tooltip.hover.left title="Add picture" for="image">
                                            <Thumbnail
                                                id="cover-img"
                                                v-if="cover"
                                                size="medium"
                                                :data="{image: cover}"
                                                class-name="w-100 cover-img" />
                                            <DefaultUploadPlace id="default-upload-place" v-else/>
                                            <input
                                                id="image"
                                                type="file"
                                                accept=".png, .jpg, .jpeg, .gif"
                                                @change="onImageUpload($event.target.files[0])"
                                                class="d-none"/>
                                        </label>
                                        <div id="err-box" class="err-box" v-if="uploadingError">
                                            <span id="uploading-err" class="c5o7 lab">
                                                {{uploadingError}}
                                            </span>
                                        </div>
                                        <span id="uploading-cover" v-if="uploadingCover">
                                            Uploading...<br/>
                                            Please wait for upload to complete.
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-7 col-12">
                                <div class="right-side right-side mt-sm-0 mt-5">
                                    <div class="title-input mb-3">
                                        <input
                                            id="title-input"
                                            class="p2b w-100 form-field"
                                            maxlength="60"
                                            v-model="title"
                                            placeholder="Title"
                                            type="text">
                                    </div>
                                    <div class="desc-textarea">
                                        <md-field id="textarea-field" class="pt-0">
                                            <md-textarea
                                                id="desc-textarea"
                                                class="pt-2 form-field"
                                                v-model="desc"
                                                maxlength="400"
                                                placeholder="Project description"/>
                                        </md-field>
                                    </div>
                                    <div class="optional-link position-relative">
                                        <input
                                            id="pixel-id-input"
                                            v-b-tooltip.hover.left
                                            title="Add to retarget visitors"
                                            type="text"
                                            placeholder="Facebook Pixel ID"
                                            class="w-100 form-field"
                                            :class="{error: !validPixelId}"
                                            v-model="facebookPixelId">
                                    </div>
                                    <div id="err-box-id" class="err-box">
                                        <span id="invalid-id-text" v-if="!validPixelId" class="c5o7 lab">
                                            Invalid ID
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import {
        getDataByDocId,
        updateData,
        uploadImage
    } from '../../firebaseCRUD';
    import { DefaultUploadPlace } from '../Icons'
    import Heading from '../Theme/Heading'
    import {DEFAULT_CAMPAIGN_COLLECTION} from "../../firebase";
    import {validateUploading} from "../../core/_validateUploading";
    import Thumbnail from '../Theme/Thumbnail'

    export default {
        name: "AddCrossPromInfo",
        components: {
            DefaultUploadPlace,
            Heading,
            Thumbnail
        },
        props: {
            cardData: Object
        },
        data: function() {
            return {
                title: '',
                desc: '',
                facebookPixelId: '',
                cover: null,
                platform: '',
                uploadingCover: false,
                validPixelId: true,
                uploadingError: ''
            }
        },
        watch: {
            'title': 'onChange',
            'desc': 'onChange',
            'facebookPixelId': 'validatePixelId',
            'cover': 'onChange',
            'cardData':'initData'
        },
        mounted: function() {
            this.onChange();
            this.$emit('setChildEvent', {
                next: this.saveData,
                prev: this.saveData
            });
            if(this.cardData){
                this.initData(this.cardData);
            }
        },
        methods: {
            validatePixelId(val){
                // if it has a value, check its length and if it contains only digits.
                this.validPixelId = !(val.length && (!/^\d+$/.test(val) || val.length < 15 || val.length > 16));
                this.$emit('disableNext', !this.validPixelId);

                if(this.validPixelId){
                    this.$emit('setChildEvent', {
                        next: this.saveData,
                        prev: this.saveData
                    });
                } else {
                    this.$emit('setChildEvent', null);
                }
                this.onChange();
            },
            async initData (obj) {
                if(!obj) return;
                this.title = obj.promo_title || obj.title || ''
                this.desc = obj.promo_desc || ''
                this.facebookPixelId = obj.facebook_pixel || ''
                this.platform = obj.platform


                if(!obj.promo_image) {
                    let doc = await getDataByDocId({ 
                        id: this.$route.query.id,
                        collection: DEFAULT_CAMPAIGN_COLLECTION
                    })
                    this.cover = doc.data().promo_image || obj.image
                } else {
                    this.cover = obj.promo_image
                }
            },
            onChange: function () {
                this.$emit('showNext',
                    (this.title.length ||
                    this.desc.length || (this.validPixelId && this.facebookPixelId.length))
                )
            },
            createObjectURL: function(e) {
                return (window.URL) ? window.URL.createObjectURL(e) : window.webkitURL.createObjectURL(e);
            },
            async onImageUpload(file) {
                if(!file) {
                    return;
                }
                this.uploadingError = validateUploading(file);
                if(this.uploadingError) {
                    return
                }
                this.uploadingCover = true
                this.cover = this.createObjectURL(file)
                try {
                    this.cover = await uploadImage(file)
                    this.$sendMixpanelEvent('Add Wizard', {
                        'Step Number': 3,
                        'Action': 'Pic Uploaded'
                    })
                    this.$ga.event('Add Wizard', 'Upload Pic', 'Step', 3)
                } catch(err) {
                    this.$store.dispatch('handleErrors', err)
                } finally {
                    this.uploadingCover = false
                }
            },
            saveData: async function() {

                // check if we have an edited data
                if (this.cardData && this.cover === this.cardData.promo_image
                    && this.title === this.cardData.promo_title
                    && this.desc === this.cardData.promo_desc
                    && this.facebookPixelId === this.cardData.facebook_pixel
                ) return;

                if(this.desc && this.desc !== this.cardData.promo_desc){
                    this.$sendMixpanelEvent('Add Wizard', {
                        'Step Number': 3,
                        'Action': 'Description Added'
                    })
                    this.$ga.event('Add Wizard', 'Add Description', 'Step', 3)
                }

                if(this.title && this.title !== this.cardData.promo_title){
                    this.$sendMixpanelEvent('Add Wizard', {
                        'Step Number': 3,
                        'Action': 'Title Changed'
                    })
                    this.$ga.event('Add Wizard', 'Change Title', 'Step', 3)
                }

                if(this.facebookPixelId && this.facebookPixelId !== this.cardData.facebook_pixel) {
                    this.$sendMixpanelEvent('Add Wizard', {
                        'Step Number': 3,
                        'Action': 'Pixel Added'
                    })
                    this.$ga.event('Add Wizard', 'Add FB Pixel ', 'Step', 3)
                }

                try {
                    const data = {
                        promo_image: this.cover,
                        promo_title: this.title || this.cardData.title,
                        promo_desc: this.desc,
                        facebook_pixel: this.facebookPixelId
                    };

                    await updateData({
                        id: this.$route.query.id,
                        collection: DEFAULT_CAMPAIGN_COLLECTION,
                        data
                    });
                    this.$emit('setData', {
                        ...this.cardData,
                        ...data
                    })
                } catch (e) {
                    this.$store.dispatch('handleErrors', e)
                }
            },
        }
    }
</script>
<style scoped lang="scss">
    .wizard-content {
        .cover-img {
            max-height: 300px;
            object-fit: cover;
            cursor: pointer;
        }
        .left-side {
            .img-info {
                line-height: 1.3;
            }
        }
        .right-side {
            .title-input, .desc-textarea, .optional-link {
                .md-field {
                    &::after, &::before {
                        display: none;
                    }
                }
            }
            .title-input {
                .md-field {
                    &.md-focused {
                        label {
                            top: -8px !important;
                            font-size: 11px !important;
                        }
                    }
                }
                label {
                    background: #FFFFFF;
                    left: 10px !important;
                    top: 15px;
                    width: 30px;
                    text-align: center;
                }
                input {
                    height: 48px;
                }
            }
            .optional-link {
                input {
                    height: 33px;
                    &.error {
                        border: 1px solid #fa5c7cb3!important;
                    }
                }
                .md-field {
                    &.md-focused {
                        label {
                            top: -9px;
                            font-size: 11px;
                        }
                    }
                }
                label {
                    top: 7px;
                    left: 8px;
                    text-align: center;
                    background: #FFFFFF;
                }
                img {
                    left: 100%;
                    top: 0;
                    transform: translate(15px,-3px);
                }
            }
        }
    }
    @media only screen and (min-width: 280px) and (max-width: 576px) {
        .optional-link img {
            transform: translate(-50px,1px);
            width: 30px;
        }
    }
</style>